@if (!expandableOff) {
<div class="flex flex-bottom flex-justify-between cursor-pointer col-1 p-t-1 w-12"
     [zippyToggle]="zippyId">
    <div class="w-9 p2 col-11 p-l-9">
        <ng-content select="[expandableTitle]"></ng-content>
    </div>
    <div class="flex-grow"></div>
    <div class="flex flex-middle p-r-2">
        <div class="p2">
            <div [zippyName]="zippyId"
                 zippyClass="ng-hide">
                {{showCopy | translate}}
            </div>
            <div [zippyName]="zippyId"
                 zippyClass="!ng-hide">
                {{ 'Hide' | translate }}
            </div>
        </div>
        <i [zippyName]="zippyId"
           class="indicator icon-chevron-down icon-medium"
           zippyClass="flip"></i>
    </div>
</div>
}

<div class="hide-up-container">
    <div class="ng-hide ng-hide-animate"
         [zippyHideUp]="zippyId"
         [zippyOff]="expandableOff"
         [zippyState]="expandContentByDefault"
         [zippyAnimationDuration]="350">
        <div [class.p-t-6]="!expandableOff">
            <ng-content select="[expandableBody]"></ng-content>
        </div>
    </div>
</div>
